export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const INITIAL_CLASSES = [
  { id: 1, name: 'Class 1A', teacher: 'Mr. Rashid', sections: ['B','C','D','Green F','New'] },
  { id: 2, name: 'II-Pre', teacher: 'Ms. Sana', sections: ['A','B'] },
  { id: 3, name: 'III-Pre', teacher: 'Ms. Hira', sections: ['A','B','C'] },
  { id: 4, name: '11', teacher: 'Mr. Ali', sections: ['Science','Arts'] },
  { id: 5, name: 'I', teacher: 'Ms. Nadia', sections: ['A','B','C','D'] },
  { id: 6, name: 'II', teacher: 'Mr. Kamran', sections: ['A','B'] },
  { id: 7, name: 'Ahmad Testing', teacher: 'TBA', sections: ['A'] },
];

export const INITIAL_SUBJECTS = [
  'Mathematics','English','Science','Urdu','Islamiat',
  'Social Studies','Computer','Physics','Chemistry','Biology'
];

export const INITIAL_DEPARTMENTS = [
  { id: 1, name: 'Administration', head: 'Dr. Islahudin', staff: 3 },
  { id: 2, name: 'Academics', head: 'Ms. Nadia', staff: 8 },
  { id: 3, name: 'Finance', head: 'Mr. Kamran', staff: 2 },
  { id: 4, name: 'IT', head: 'Mr. Ali', staff: 3 },
];

export const INITIAL_STAFF = [/* same as yours */];
export const INITIAL_STUDENTS = [/* same as yours */];

export const COUNTRIES = ['Pakistan','India','UAE','Saudi Arabia','UK','USA','Canada'];

export const PROVINCES = {
  Pakistan: ['Punjab','Sindh','KPK','Balochistan','ICT','AJK','GB'],
};

export const DESIGNATIONS = [
  'Principal','Vice Principal','Teacher English','Teacher Math',
  'Teacher Science','Teacher Urdu','Teacher SST','Accountant',
  'IT Administrator','Librarian','Peon',
];

export const BLOOD_GROUPS = ['A+','A-','B+','B-','AB+','AB-','O+','O-'];